import { useState, useEffect } from "react";
import { fetchWithCache } from "../utils/apiCache";

export const useCertifications = () => {
    const [certifications, setCertifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCertifications = async () => {
            try {
                setLoading(true);
                const url = `${process.env.REACT_APP_BACKEND_URL}/certifications/`;
                const result = await fetchWithCache(url);

                // Manejar diferentes formatos de respuesta
                let certificationsArray = [];

                if (result.status === 200 && result.data) {
                    // result.data es el array directamente
                    if (Array.isArray(result.data)) {
                        certificationsArray = result.data;
                    }
                    // result.data es un objeto con {status, data} (doble envoltura)
                    else if (result.data.status === 200 && Array.isArray(result.data.data)) {
                        certificationsArray = result.data.data;
                    }
                }

                setCertifications(certificationsArray);
                setError(null);
            } catch (err) {
                console.error("Error fetching certifications:", err);
                setError(err.message);
                setCertifications([]);
            } finally {
                setLoading(false);
            }
        };

        fetchCertifications();
    }, []);

    return { certifications, loading, error };
};
